const logOut =()=>{
    localStorage.removeItem('token')
    window.location.reload()
}

export default logOut